import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { NodInsightsRoute } from "./nod-insight.routes";

export function NodInsights() {
  return (
    <Layout>
      {NodInsightsRoute.subRoutes && (
        <ModuleRouter subRoutes={NodInsightsRoute.subRoutes} path={NodInsightsRoute.path} />
      )}
    </Layout>
  );
}
